import type { Channel } from "@/types/channel";
import { type ErrorType, type PageRes, apiRequest } from "../api";

interface ChannelQueryParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const channelService = {
  async getAll(params: ChannelQueryParams = {}): Promise<[PageRes<Channel> | null, ErrorType | null]> {
    return apiRequest<PageRes<Channel>>({
      loaderKey: "getAllChannels",
      method: 'get',
      url: "/app/channels",
      params
    });
  },

  async create(channel: Omit<Channel, "_id">): Promise<[Channel | null, ErrorType | null]> {
    const result = await apiRequest<Channel>({
      loaderKey: "createChannel",
      method: "post",
      url: "/app/channels",
      data: channel,
    });

    return result;
  },

  async update(id: string, channel: Partial<Channel>): Promise<[Channel | null, ErrorType | null]> {
    const result = await apiRequest<Channel>({
      loaderKey: "updateChannel",
      method: "put",
      url: `/app/channels/${id}`,
      data: channel,
    });

    return result;
  },

  async delete(id: string): Promise<[null | null, ErrorType | null]> {
    const result = await apiRequest<null>({
      loaderKey: "deleteChannel",
      method: "delete",
      url: `/app/channels/${id}`,
    });

    return result;
  },

  async toggleStatus(id: string, isActive: boolean): Promise<[Channel | null, ErrorType | null]> {
    const result = await apiRequest<Channel>({
      loaderKey: "toggleChannelStatus",
      method: "put",
      url: `/app/channels/${id}/status`,
      data: { isActive },
    });

    return result;
  }
}; 